import React from "react";
import { Props } from "./types";

const AutoFocusContext = React.createContext<Props>({
  lastAllocatedTaskUuid: null,
  lastAllocatedProjectUuid: null,
  lastAllocatedResourceUuid: null,
  clearLastAllocated: () => {},
});

export { AutoFocusContext };
